import { render, staticRenderFns } from "./DownloadInstallerCard.vue?vue&type=template&id=1bb91180&scoped=true&"
import script from "./DownloadInstallerCard.vue?vue&type=script&lang=js&"
export * from "./DownloadInstallerCard.vue?vue&type=script&lang=js&"
import style0 from "./DownloadInstallerCard.vue?vue&type=style&index=0&id=1bb91180&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb91180",
  null
  
)

export default component.exports